import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction} from "lodash";
import { initialFilter } from "./ActivityUIHelper";
const ActivityUIContext = createContext();

export function useActivityUIContext() {
  return useContext(ActivityUIContext);
}

export const ActivityUIConsumer = ActivityUIContext.Consumer;

export function ActivityUIProvider({ children }) {

  const [queryParams, setQueryParamsBase] = useState(initialFilter);

  // Query Params set when do pagination ,filter,search
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

 

  const value = {
    
    queryParams,
    setQueryParamsBase,
    setQueryParams,
  };

  console.log(value)

  return (
    <ActivityUIContext.Provider value={value}>{children}</ActivityUIContext.Provider>
  );
}
